import type {
  IntegrationRequestDetail,
  IntegrationRequestWebhook,
} from '../../../../models/IntegrationRequest';
import { integrationWebhooksUrl } from '../../../IntegrationWebhooks/config';
import { NotificationSeverity } from '@/components/notifications/Notification';
import { buildWebhookNoticeText } from '../../utils/buildIntegrationTexts';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { copyToClipboard } from '@/utils/copyToClipboard';
import { useNavigate } from 'react-router-dom';
import { GlobalButton } from '@/components';
import { useIsIntegrationIt } from '../../hooks';
import { useNotification } from '@/hooks';
import CopyableText from './CopyableText';
import DetailCard from './DetailCard';
import { useMemo } from 'react';

interface WebhookDeliveryProps {
  request: IntegrationRequestDetail;
  webhook: IntegrationRequestWebhook;
}

const WebhookDelivery = ({ request, webhook }: WebhookDeliveryProps) => {
  const navigate = useNavigate();
  const isIt = useIsIntegrationIt();
  const { showNotification } = useNotification();
  const noticeText = useMemo(
    () =>
      buildWebhookNoticeText(
        request.commerce?.name ?? 'el comercio',
        webhook.url,
        request.webhookStatuses.map((status) => status.name)
      ),
    [request, webhook]
  );

  const copy = async () => {
    const copied = await copyToClipboard(noticeText);
    showNotification(
      copied ? 'Texto del aviso copiado' : 'No se pudo copiar el texto del aviso',
      copied ? NotificationSeverity.success : NotificationSeverity.error
    );
  };

  return (
    <DetailCard
      title='Aviso al cliente'
      action={
        isIt && (
          <GlobalButton
            variant={GlobalButtonVariant.secondaryButton}
            action={() => navigate(integrationWebhooksUrl(request.commerceId))}
          >
            Ver webhooks del comercio
          </GlobalButton>
        )
      }
    >
      <p className='text-sm text-gray-600'>
        {isIt
          ? 'El webhook quedó activo. Pruébelo poniendo en ruta un pedido del comercio; el resultado se ve en el último envío de la pantalla de webhooks. Cuando le avise al cliente, marque la solicitud como enviada al cliente.'
          : 'El webhook quedó activo. Cuando le avise al cliente, marque la solicitud como enviada al cliente.'}
      </p>
      <CopyableText text={noticeText} copyLabel='Copiar texto del aviso' onCopy={copy} />
    </DetailCard>
  );
};

export default WebhookDelivery;
